import { render, staticRenderFns } from "./ModalCollaboration.vue?vue&type=template&id=c8ed77c4"
import script from "./ModalCollaboration.vue?vue&type=script&lang=js"
export * from "./ModalCollaboration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ed77c4')) {
      api.createRecord('c8ed77c4', component.options)
    } else {
      api.reload('c8ed77c4', component.options)
    }
    module.hot.accept("./ModalCollaboration.vue?vue&type=template&id=c8ed77c4", function () {
      api.rerender('c8ed77c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Modals/ModalCollaboration.vue"
export default component.exports